import { useTranslation } from 'react-i18next'

import { Button, Modal } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const NoDeliveryMethodsAvailableModal = ({ show, onClose, onAccept, contactEmail }) => {
  const { t } = useTranslation()

  return (
    <Modal size="m" title={t('Región no permitida')} show={show} onClose={onClose}>
      <Styles.Container>
        <p>{t('La política de devoluciones no permite cambios o devoluciones de compras en tu región.')}</p>
        <p>
          {t('Para más información, contacta con la tienda escribiendo a ')}
          <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
        </p>
      </Styles.Container>
      <Button fullWidth onClick={onAccept}>
        {t('Aceptar')}
      </Button>
    </Modal>
  )
}

export default NoDeliveryMethodsAvailableModal
